import { AutocompleteRenderInputParams, CircularProgress } from '@mui/material'
import { theme } from 'index'

export const FieldAutocompleteInputProps = (params: AutocompleteRenderInputParams, isLoading: boolean) => ({
  ...params.InputProps,
  endAdornment: (
    <>
      {isLoading && (
        <CircularProgress
          sx={{ color: theme.palette.primary.main }}
          size={20}
        />
      )}
      {params.InputProps.endAdornment}
    </>
  ),
})
